import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import DisplayImage from '../display-image';
import Container from '@mui/material/Container';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import parse from 'html-react-parser';
import {borderRadius, colors, fontFamily, fontSize} from '@/styles/tokens';

// Migrated from globals.scss `.demand-adoption-card-wrapper` family (base rules +
// the `:hover` cross-fade between `.demand-adoption-content-wrapper` and
// `.demand-adoption-full-content`). `.demand-content-wrapper`/`.demand-full-content`
// below are now sx-only hooks — no rule for either remains in globals.scss.
const sxCardWrapper = {
    '& img': {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: borderRadius.sm,
        border: '1px solid #e0e0e0'
    },
    '& .demand-content-wrapper': {
        backgroundColor: 'hsla(0, 0%, 100%, 0.8)',
        opacity: 1
    },
    '& .demand-full-content': {
        transform: 'translateY(100%)',
        opacity: 0,
        backgroundColor: 'hsla(0, 0%, 100%, 0.8)',
        transition: 'transform 0.5s ease',
        width: '100%'
    },
    '&:hover': {
        '& .demand-content-wrapper': {transform: 'translateY(100%)', opacity: 0},
        '& .demand-full-content': {transform: 'translateY(0)', opacity: 1}
    }
};

const sxLocationWrapper = {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    right: '10px',
    top: '10px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    padding: '4px 8px',
    borderRadius: borderRadius.sm
};

const sxLocationTitle = {
    fontFamily: fontFamily.heading,
    fontSize: fontSize[14],
    color: colors.text.inverse
};

const sxCardHeading = {
    fontSize: fontSize[16],
    fontFamily: fontFamily.heading
};

const sxCardSubheading = {
    fontSize: fontSize[16],
    marginTop: '10px', // no exact spacing-token match
    fontFamily: fontFamily.body
};

const OnDemandAdoption = (props: any) => {
    const {heading, subheading, contentData} = props;
    return (
        <Box>
            <Container maxWidth="lg">
                <Box className="spectrum-header-wrapper solutions">
                    <Typography className="spectrum-heading color-black text-align-left" component="h2">
                        {heading}
                    </Typography>
                    <Box className="divder-wrapper">
                        <hr className="divider-line divider-line-left" />
                    </Box>
                    {subheading && (
                        <Box className="sub-heading-box" pb={4}>
                            <Typography className="spectrum-sub-heading color-black spacing text-align-left">{subheading}</Typography>
                        </Box>
                    )}
                </Box>
                <Grid container spacing={3}>
                    {contentData?.map((item: any, index: number) => (
                        <Grid key={index + 1} item md={4} sm={6} xs={12}>
                            <Box position="relative" borderRadius={2} sx={sxCardWrapper} overflow="hidden">
                                {item?.location && (
                                    <Box sx={sxLocationWrapper}>
                                        <LocationOnIcon sx={{color: 'white'}} />
                                        <Typography sx={sxLocationTitle}>{item.location}</Typography>
                                    </Box>
                                )}

                                <DisplayImage alt={item.heading} src={item.icon} />
                                <Box position="absolute" bottom={4} width="100%" zIndex={10} className="demand-content-wrapper">
                                    <Typography sx={sxCardHeading} p={3}>
                                        {item.heading}
                                    </Typography>
                                </Box>
                                <Box textAlign="left" position="absolute" bottom={4} p={2} className="demand-full-content">
                                    <Typography sx={sxCardHeading}>{item.heading}</Typography>
                                    <Typography sx={sxCardSubheading}>{item.subheading ? parse(item.subheading) : ''}</Typography>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default memo(OnDemandAdoption);
